import React from 'react';
import { Box, Link } from '@99designs/emu';
import { useOnboarderNav } from '../Onboarder/useOnboarderNav';
import type { GenericStepData, StepComponentProps } from '../Onboarder/Config';

export function withSkipLink(
    WrappedComponent: React.FunctionComponent<StepComponentProps<GenericStepData>>
) {
    function WithSkipLink(props: StepComponentProps<GenericStepData>) {
        const onboarderNav = useOnboarderNav();
        const { key, trackCompleted } = onboarderNav.currentStep();
        const { data, onChange } = props;

        return (
            <>
                <WrappedComponent {...props} />
                <Box marginTop="1bu" display="flex" justifyContent="flex-end">
                    <Link
                        aria-label={__('Skip this question')}
                        onClick={() => {
                            // eslint-disable-next-line @typescript-eslint/no-unused-vars
                            const { [key]: emit, ...rest } = data;
                            onChange(rest);

                            trackCompleted(rest, onboarderNav.currentStepIndex() + 1);

                            if (onboarderNav.isLastStep()) {
                                onboarderNav.goToRecommendation(rest);
                                return;
                            }
                            onboarderNav.goToNextStep();
                        }}
                    >
                        {__('Skip this question')}
                    </Link>
                </Box>
            </>
        );
    }

    const wrappedComponentName =
        WrappedComponent.displayName || WrappedComponent.name || 'Component';

    WithSkipLink.displayName = `withSkipLink(${wrappedComponentName})`;

    return WithSkipLink;
}
